import React from "react";
import SupportKnowledge from "../SupportKnowledge";
import { Label } from "./IdentityTab";

export function PersonaTab({ a, set, readOnly, isNew }) {
  return (
    <div data-testid="agent-persona">
      <div className="aivora-card space-y-4 p-5">
        <label className="block"><Label hint={`${(a.system_prompt || "").length.toLocaleString("id-ID")}/20.000`}>System prompt</Label>
          <textarea className="input-ui font-mono text-xs" rows={12} maxLength={20000} disabled={readOnly} value={a.system_prompt || ""} onChange={(e) => set({ system_prompt: e.target.value })} data-testid="agent-prompt" /></label>
        <label className="block"><Label hint={`${(a.knowledge || "").length.toLocaleString("id-ID")}/60.000`}>Teks knowledge dasar</Label>
          <textarea className="input-ui font-mono text-xs" rows={8} maxLength={60000} disabled={readOnly} value={a.knowledge || ""} onChange={(e) => set({ knowledge: e.target.value })} data-testid="agent-knowledge" /></label>
      </div>
      {isNew ? <p className="mt-6 rounded-xl bg-slate-50 px-4 py-4 text-xs text-slate-500" data-testid="agent-kb-needs-save">Simpan agent dulu untuk menambahkan dokumen knowledge.</p>
        : <SupportKnowledge base={`/platform/support-agents/${a.id}/knowledge`} readOnly={readOnly} />}
    </div>
  );
}
